<div *ngIf="Title" class="modal-header">
    <h4 class="modal-title">{{ Title }}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="CloseText" (click)="Close();"></button>
</div>
<div class="modal-body">
    <div [innerHTML]="Content$ | async"></div>
</div>
<div *ngIf="CloseText" class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="Close()">{{ CloseText }}</button>
</div>

<ng-template #stringTpl let-popup>
    <p [ngClass]="popup.ngClass">{{ popup.Message }}</p>
</ng-template>